import React, { useContext, useState, useEffect } from "react";
import { ThemeContext } from "../../context";
import "./intro.css";

const Intro = () => {
    const theme = useContext(ThemeContext);
    const { theme: currentTheme } = theme.state;
    const [content, setContent] = useState({
        name: "Prabindra Sapkota",
        title: "Game Developer & Gameplay Programmer",
        description: "Crafting immersive game experiences with 4+ years of professional expertise in C# gameplay systems, modular architecture, and performance optimization. Specialized in mobile and WebGL platforms.",
        tags: ["Unity", "C#", "Gameplay", "Mobile"]
    });

    useEffect(() => {
        // Load content from JSON
        fetch("/content.json")
            .then(res => res.json())
            .then(data => {
                setContent({
                    name: data.name || content.name,
                    title: data.title || content.title,
                    description: data.description || content.description,
                    tags: data.tags || content.tags
                });
            })
            .catch(err => console.log("Using default intro content"));
    }, []);

    return (
        <section id="intro" className="pt-24 pb-20 md:pt-32 md:pb-28 transition-colors duration-300">
            <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
                <div className="space-y-8 md:space-y-12">
                    {/* Main Headline */}
                    <div className="space-y-4">
                        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight">
                            <span className="block">Hi, I'm</span>
                            <span className="block glow-accent" style={{color: 'rgb(var(--accent-color))'}}>
                                {content.name}
                            </span>
                        </h1>
                        <p className="text-xl md:text-2xl" style={{color: 'rgb(var(--text-secondary))'}}>
                            {content.title}
                        </p>
                    </div>

                    {/* Description */}
                    <p className="text-lg md:text-xl leading-relaxed max-w-3xl" style={{color: 'rgb(var(--text-secondary))'}}>
                        {content.description}
                    </p>

                    {/* Tech Stack */}
                    <div className="space-y-3">
                        <p className="text-sm font-semibold uppercase tracking-widest" style={{color: 'rgb(var(--text-secondary))'}}>
                            Tech Stack
                        </p>
                        <div className="flex flex-wrap gap-2">
                            {content.tags && content.tags.map((tag, idx) => (
                                <span 
                                    key={idx}
                                    className="badge"
                                >
                                    {tag}
                                </span>
                            ))}
                        </div>
                    </div>

                    {/* CTA Button */}
                    <div className="pt-4">
                        <a 
                            href="#projects"
                            className="inline-flex items-center gap-3 px-8 py-4 rounded-lg text-white font-semibold transition-all duration-300"
                            style={{background: 'rgb(var(--accent-color))'}}
                        >
                            Explore My Work
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Intro;
